import Vue from 'vue'
import { travelSingleItem } from '../travel.config.inc.js'
import { fullImage } from '../images.config.inc.js'

const singleItem = {
  state: {
    singleImageSrc:{},
    singleImage: {},
    currentIndex: 0,
    cachedImages: [],
  },
  getters: {
    getSingleImageSrc: state => state.singleImageSrc,
    getSingleImage: state => state.singleImage,
    getCurrentIndex: state => state.currentIndex,
    getCachedImages: state => state.cachedImages
  },
  mutations: {
    changeSingleImage: (state, payload) => {
      state.singleImageSrc = payload.imageSrc;
      state.singleImage = payload.image;
      state.currentIndex = payload.currentIndex >= 0 ? payload.currentIndex : state.currentIndex;
    },
    resetCurrentIndex: (state) => {
      state.currentIndex = null
    },
    cacheImages: (state, payload) => {
      state.cachedImages.push(payload);
    }
  },
  actions: {
    selectSingleItem: (context, payload) => {
      context.commit('changeSingleImage', payload);
      context.dispatch('retrieveCoordinates', payload.image);
    },
    retrieveSingleItemByParams: (context, payload) => {
      return Vue.axios.get(`${travelSingleItem}${payload}`)
        .then((data) => {
          const newImage = {
            image: data.data,
            imageSrc: `${fullImage}${data.data._source.resource_id}.jpg`,
          }
          context.commit('changeSingleImage', newImage);
        })
        .catch((err) => {
          console.warn(err);
        })
    },
    resetCurrentIndex: (context) => {
      context.commit('resetCurrentIndex');
    },
    retrieveNextItems: ({getters, commit, state}) => {
      state.cachedImages.length = 0;
      const searches = [-1, 1];

      searches.forEach((num) => {
        return Vue.axios.get(`${travelSingleItem}${getters.getMatchedImages[state.currentIndex + num]._source.resource_id}`)
          .then((data) => {
            const img = new Image();
            img.onload = ()=> {
              commit('cacheImages', img.src);
            }
            img.src = `${fullImage}${data.data._source.resource_id}.jpg`
          })
          .catch((err) => {
            console.warn(err);
          })
      })
    }
  }
}

export default singleItem



// WEBPACK FOOTER //
// ./src/store/singleItem.js